export var NativeShareEventType;
(function (NativeShareEventType) {
    NativeShareEventType["SHARE_RECEIVED"] = "sharedReceived";
})(NativeShareEventType || (NativeShareEventType = {}));
//# sourceMappingURL=definitions.js.map